import { markRaw } from 'vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import type { EstateProject } from '@/modules/estate-project/types/estate-project-types'
import moment from 'moment'

export const createEstateProjectTableConfig = () => ({
  canShowHide: true,
  columns: {
    id: {
      label: 'ID',
      component: markRaw(TextCell),
      class: 'estate-project-cell-bold',
      visible: true,
      sort: false,
      config: {},
    },
    project_name: {
      label: 'Tên dự án',
      component: markRaw(TextCell),
      class: 'estate-project-col-project-name estate-project-cell-bold',
      visible: true,
      sort: false,
      config: {},
    },
    project_address: {
      label: 'Địa chỉ',
      component: markRaw(TextCell),
      class: 'estate-project-col-project-address',
      visible: true,
      sort: false,
      config: {},
    },
    created_at: {
      label: 'Thời gian tạo',
      component: markRaw(TextCell),
      class: 'estate-project-cell-bold',
      visible: true,
      sort: false,
      config: {},
    },
    created_by_name: {
      label: 'Người tạo',
      component: markRaw(TextCell),
      class: '',
      visible: true,
      sort: false,
      config: {},
    },
  },
})

export const estateProjectTableConfig = createEstateProjectTableConfig()

export const formatTableDataEstateProject = (data: EstateProject[]) => {
  return data.map((item) => {
    const createdAtMoment = moment(item.created_at)
    const formattedCreatedAt = createdAtMoment.isValid()
      ? createdAtMoment.format('YYYY-MM-DD HH:mm:ss')
      : '--'

    return {
      ...item,
      id: String(item.id),
      created_at: formattedCreatedAt,
      created_by_name: item.created_by_name || '--',
    }
  })
}
